class ShippingScheduler {
    constructor(warehouse) {
        this.warehouse = warehouse || 'eu';
        if (this.warehouse === 'us') {
            this.timezone = 'America/Los_Angeles';
        } else {
            this.timezone = 'Europe/Paris';
        }
    }

    getWarehouseTime() {
        var now = new Date();
        var str = now.toLocaleString('en-US', { timeZone: this.timezone });
        return new Date(str);
    }

    getHolidays(year) {
        if (this.warehouse === 'us') {
            return this._usHolidays(year);
        }
        return this._frHolidays(year);
    }

    _frHolidays(year) {
        var holidays = [
            year + '-01-01', // New Year
            year + '-05-01', // Labour Day
            year + '-05-08', // Victory in Europe
            year + '-07-14', // Bastille Day
            year + '-08-15', // Assumption
            year + '-11-01', // All Saints
            year + '-11-11', // Armistice
            year + '-12-25', // Christmas
        ];
        var easter = this._computeEaster(year);
        holidays.push(this._dateToStr(easter));
        var easterMon = new Date(easter);
        easterMon.setDate(easter.getDate() + 1);
        holidays.push(this._dateToStr(easterMon));
        var ascension = new Date(easter);
        ascension.setDate(easter.getDate() + 39);
        holidays.push(this._dateToStr(ascension));
        var whitMon = new Date(easter);
        whitMon.setDate(easter.getDate() + 50);
        holidays.push(this._dateToStr(whitMon));
        return holidays;
    }

    _usHolidays(year) {
        var holidays = [
            year + '-01-01', // New Year
            year + '-07-04', // Independence Day
            year + '-11-11', // Veterans Day
            year + '-12-25', // Christmas
        ];
        holidays.push(this._nthWeekday(year, 1, 1, 3));
        holidays.push(this._nthWeekday(year, 2, 1, 3));
        holidays.push(this._lastWeekday(year, 5, 1));
        holidays.push(this._nthWeekday(year, 9, 1, 1));
        holidays.push(this._nthWeekday(year, 10, 1, 2));
        holidays.push(this._nthWeekday(year, 11, 4, 4));
        return holidays;
    }

    _computeEaster(year) {
        var a = year % 19;
        var b = Math.floor(year / 100);
        var c = year % 100;
        var d = Math.floor(b / 4);
        var e = b % 4;
        var f = Math.floor((b + 8) / 25);
        var g = Math.floor((b - f + 1) / 3);
        var h = (19 * a + b - d - g + 15) % 30;
        var i = Math.floor(c / 4);
        var k = c % 4;
        var l = (32 + 2 * e + 2 * i - h - k) % 7;
        var m = Math.floor((a + 11 * h + 22 * l) / 451);
        var month = Math.floor((h + l - 7 * m + 114) / 31);
        var day = ((h + l - 7 * m + 114) % 31) + 1;
        return new Date(year, month - 1, day);
    }

    _nthWeekday(year, month, weekday, n) {
        var d = new Date(year, month - 1, 1);
        var count = 0;
        while (count < n) {
            if (d.getDay() === weekday) count++;
            if (count < n) d.setDate(d.getDate() + 1);
        }
        return this._dateToStr(d);
    }

    _lastWeekday(year, month, weekday) {
        var d = new Date(year, month, 0);
        while (d.getDay() !== weekday) {
            d.setDate(d.getDate() - 1);
        }
        return this._dateToStr(d);
    }

    _dateToStr(d) {
        var m = String(d.getMonth() + 1).padStart(2, '0');
        var day = String(d.getDate()).padStart(2, '0');
        return d.getFullYear() + '-' + m + '-' + day;
    }

    _isHoliday(date) {
        var str = this._dateToStr(date);
        var holidays = this.getHolidays(date.getFullYear());
        return holidays.indexOf(str) !== -1;
    }

    _isBusinessDay(date) {
        var day = date.getDay();
        if (day === 0 || day === 6) return false;
        if (this._isHoliday(date)) return false;
        return true;
    }

    getNextBusinessDay(fromDate, locale) {
        var next = new Date(fromDate);
        next.setDate(next.getDate() + 1);
        while (!this._isBusinessDay(next)) {
            next.setDate(next.getDate() + 1);
        }
        return next.toLocaleDateString(locale, { weekday: 'long' });
    }

    getShippingTime(clientTime, shippingType, locale) {
        var whTime = this.getWarehouseTime();
        var cutoffHour = 12;

        var cutoffTime = new Date(whTime);
        cutoffTime.setHours(cutoffHour, 0, 0, 0);

        if (!this._isBusinessDay(whTime)) {
            return this.getNextBusinessDay(whTime, locale);
        } else if (whTime.getTime() < cutoffTime.getTime()) {
            return "today";
        } else {
            return this.getNextBusinessDay(whTime, locale);
        }
    }

    timeRemaining(clientTime, shippingType, locale) {
        var whTime = this.getWarehouseTime();

        if (!this._isBusinessDay(whTime)) {
            return null;
        }

        var cutoffHour = 12;
        var cutoffTime = new Date(whTime);
        cutoffTime.setHours(cutoffHour, 0, 0, 0);

        var timeDifference = cutoffTime - whTime;
        var hoursRemaining = Math.floor(timeDifference / (1000 * 60 * 60));
        var minutesRemaining = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

        if (hoursRemaining < 3 && timeDifference > 0) {
            if (hoursRemaining > 0) {
                return hoursRemaining + ' ' + (hoursRemaining > 1 ? 'hours' : 'hour');
            } else {
                return minutesRemaining + ' ' + (minutesRemaining > 1 ? 'minutes' : 'minute');
            }
        }

        return null;
    }
}
